export { Body } from "./Body"
export type { BodyProps } from "./Body"
